<template>
  <app-layout>
     <template v-slot:headerTitle>
        Application Settings
    </template>
   
   
    <br>
    <template v-slot:tcsetttingnav>
    </template>
     <template v-slot:tcmainnav>
    </template>
    
  <div class="py-6 px-8" style="background-color:#F3F4F6">
  
  <div class="container bg-white border">
     <h4 class="px-3 py-3 font-bold">Organisation</h4>
  <form action="#" method="POST">
          <div class="sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-2 space-y-6 sm:p-6">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-2 sm:col-span-2">
                 <DxForm :form-data="form_data" @field-data-changed="drop_down_change" :label-location="labelLocation">
                     <DxGroupItem
                          :col-count="1"
                          css-class="second-group"
                        >
                    <DxGroupItem>
                            <DxSimpleItem
                            :editor-options="CIN"
                                    data-field="CIN"
                            />
                            <DxSimpleItem
                                    data-field="PAN"
                            />
                            <DxSimpleItem
                                    data-field="Fin Year Start"
                            />
                            <DxSimpleItem
                                    data-field="Is GST"
                            />
                             </DxGroupItem>  
                             </DxGroupItem>  
                     </DxForm>
                </div>
              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <jet-button type="submit" @click="update" class="bg-blue-500 rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline"> Update </jet-button>
            </div>
             <DxToast
                        v-model:visible="isVisible"
                        v-model:message="messag"
                        v-model:type="type"
                      />
          </div>
        </form>
  </div>
  </div>
  </app-layout>
</template>
<script>  
import JetNavLink from '@/Jetstream/NavLink.vue';
//import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxTextBox from 'devextreme-vue/text-box';
import { DxToast } from 'devextreme-vue/toast';
import {getConfigurationCredentials,save_user_credentials} from './js/configuration.js';
import {isElectron} from "@include/pages/modules/UtilsJs/utils.js";
import {
  DxLabel,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
} from 'devextreme-vue/form';
const modelData = {};
export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    modelData:{
        type: Object,
        default: () => ({})
    },
  },
  components: {
    DxLabel,
    AppLayout,
    BsEdit,
    PageTitle,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    JetNavLink,
    DxToast
  },
  data: function () {
    return {
      isVisible: false,
      message: '',
      toastType: 'info',
      form_data:{"ip_address":"","port_no":"","License_no":""},
      title:this.moduleRoute+" Create",
      isVisible: false,
      messag: '',
      type: 'info',
      labelLocation:'top',
      metas:'',
    };
  },
  methods: {
    checkAction()
    {
      return (this.modelData.hasOwnProperty("id") && this.modelData.id != "")
    },
    update()
    {
             var _this = this;
            // console.log(this.form_data , "check")
              save_user_credentials(this.form_data,_this);
              //save_user_credentials(this.$refs.formRenderer.formData);
              // this.$inertia.put(route(this.moduleRoute+'.update',this.modelData.id),this.$refs.formRenderer.formData)
    },
    submit() {
              // console.log(this.$refs.formRenderer.formData)                
              // this.$inertia.post('/'+this.moduleRoute, this.$refs.formRenderer.formData)
    },
  },
  mounted() {
  // console.log("createDef");
  // console.log(this.createDef);
   var _this=this;
    if(isElectron()){
              this.messag = this.message;
              this.is_electron = true;
              this.metas = "electron";
              window.api.send('checkTallyOpening'); 
              window.api.receive("checkTallyOpening-reply", (tally_response) => {
                    if(tally_response == "tally is not open"){
                          this.tally_is_open = false;
                          this.messag = tally_response;
                          this.isVisible = true;
                           getConfigurationCredentials(_this,this.metas,this.license_no);
                    }
                    else if(tally_response == "tally is open"){
                          this.tally_is_open = true;
                          getConfigurationCredentials(_this,this.metas,this.license_no);
                    }
              });
          }
          else{
              this.is_electron = false;
              this.messag = this.message;
              if(this.messag == "You Dont have a valid license number for this service"){
                this.isVisible = true; 
              }
              axios.post('/checkTallyIsOpen')
                .then((result) => {
                    if(result.data!="not_open"){
                          this.tally_is_open = true;
                    }
                    else{
                          this.tally_is_open = false;
                          this.messag = "tally is not open";
                          this.isVisible = true;
                    }
                })
          }
     
  },
};
</script>
<style>

.main-page {
  /* background-color: #f3f4f6; */
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  /* margin-left: 212px;
  padding-bottom: 10px; */
} 
.edit_view{
  height: 84vh;
}
.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #2A66B1;
  background: transparent;
}
.modal-header {
  position: relative;
  border-bottom: 1px solid #EEEEEE;
  color: #2A66B1;
  justify-content: space-between;  
}
p{
  margin-bottom:0.1rem;
}
.data-field{
  font-size: 20px;
  font-weight: 800;
}
</style>